<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex xs12 md4>
        <material-card class="v-card-profile">
          <v-avatar slot="offset" class="mx-auto d-block" size="130">
            <img
              src="https://avataaars.io/?avatarStyle=Circle&topType=LongHairFroBand&accessoriesType=Prescription02&hairColor=Blonde&facialHairType=BeardMagestic&facialHairColor=Blonde&clotheType=ShirtCrewNeck&clotheColor=PastelYellow&eyeType=Cry&eyebrowType=UnibrowNatural&mouthType=Smile&skinColor=Pale"
            />"
          </v-avatar>
          <v-card-text>
            <div class="text-xs-center">
              <h6 class="category text-gray font-weight-thin mb-3">{{customer_external_id}}</h6>
              <h4 class="card-title font-weight-light">{{customer_name}}</h4>
            </div>
            <div class="card-description font-weight-light">
              <p>
                <v-icon>mdi-account-box</v-icon>
                {{primary_contact}}
              </p>
              <p>
                <v-icon>mdi-phone</v-icon>
                {{phone}}
              </p>
              <p>
                <v-icon>mdi-email</v-icon>
                {{email}}
              </p>
              <p>
                <v-icon>mdi-map-marker</v-icon>
                {{address1}} | {{city}} | {{state}} | {{zip}}
              </p>
              <p>
                <v-icon>mdi-calendar-range</v-icon>
                Active since : {{active_since | moment("dddd, MMMM Do YYYY") }}
              </p>
            </div>
          </v-card-text>
        </material-card>
      </v-flex>
      <v-flex xs12 md8>
        <v-layout row wrap>
          <v-flex md6 sm12>
            <material-stats-card
              color="green"
              icon="mdi-cash-multiple"
              title="YTD Commission"
              :value="ytd_commission | toCurrency"
              sub-icon="mdi-calendar"
              :sub-text="'All commissions - ' + all_commission | toCurrency"
            />
          </v-flex>
          <v-flex md6 sm12>
            <material-stats-card
              color="orange"
              icon="mdi-content-copy"
              title="Current Year Premium"
              :value="current_year_premium | toCurrency"
              sub-icon="mdi-calendar"
              :sub-text="'Total Lives - ' + total_lives"
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md6>
            <material-stats-card
              color="red"
              icon="mdi-information-outline"
              title="Last Commission Paid Date"
              :value="last_commission_paid_date"
              sub-icon="mdi-tag"
              :sub-text="'Last commission paid amount -' +  last_commission_paid_amount"
            />
          </v-flex>
          <v-flex md6>
            <material-stats-card
              color="info"
              icon="mdi-twitter"
              title="Followers"
              value="+245"
              sub-icon="mdi-update"
              sub-text="Just Updated"
            />
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- Coverages -->
      <v-flex xs12 md8>
        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedItem.coverage_external_id" label="Coverage"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedItem.carrier_external_id" label="Carrier"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedItem.effective_date" label="Effective Date"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedItem.status" label="Status"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedItem.actual_premium" label="Premium"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedItem.actual_commission" label="Commission"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <material-card color="primary" title="Coverages" text="Coverages for this customer">
          <v-card-text>
            <v-flex slot="actions">
              <v-btn color="primary" @click="dialog = true">Add Coverage</v-btn>
            </v-flex>
          </v-card-text>

          <v-data-table :headers="headers" :items="items" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span v-text="header.text" />
            </template>
            <template slot="items" slot-scope="{ index, item }">
              <td>{{ item.coverage_external_id }}</td>
              <td>{{ item.carrier_external_id }}</td>
              <td>{{ item.effective_date }}</td>
              <td>{{ item.status }}</td>
              <td>{{ item.actual_premium }}</td>
              <td>
                <v-dialog max-width="290">
                  <div slot="activator">{{ item.actual_commission }}</div>
                  <v-card>
                    <v-card-title class="headline">Use Google's location service?</v-card-title>

                    <v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn
                        color="green darken-1"
                        flat="flat"
                        @click="commissionDialog = false"
                      >Disagree</v-btn>

                      <v-btn
                        color="green darken-1"
                        flat="flat"
                        @click="commissionDialog = false"
                      >Agree</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </td>
              <td>
                <v-tooltip top content-class="top">
                  <v-icon slot="activator" small @click="editItem(item)">mdi-pencil</v-icon>
                  <span>Edit</span>
                </v-tooltip>
                <v-tooltip top content-class="top">
                  <v-icon slot="activator" small @click="deleteItem(item)">mdi-delete</v-icon>
                  <span>Delete</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>

      <!--End Coverages-->

      <!--TODO-->
      <v-flex xs12 md4>
        <material-card class="card-tabs" color="green">
          <v-flex slot="header">
            <v-tabs v-model="tabs" color="transparent" slider-color="white">
              <span class="subheading font-weight-light mr-3" style="align-self: center">Actions:</span>
              <v-tab class="mr-3">TODO</v-tab>
              <v-tab class="mr-3">History</v-tab>
            </v-tabs>
          </v-flex>

          <v-tabs-items v-model="tabs">
            <v-tab-item v-for="n in 1" :key="n">
              <v-list three-line>
                <v-list-tile @click="complete(0)">
                  <v-list-tile-action>
                    <v-checkbox :value="list[0]" color="green" />
                  </v-list-tile-action>
                  <v-list-tile-title>Sign contract for "What are conference organized afraid of?"</v-list-tile-title>
                  <div class="d-flex">
                    <v-tooltip top content-class="top">
                      <v-btn slot="activator" class="v-btn--simple" color="danger" icon>
                        <v-icon color="error">mdi-close</v-icon>
                      </v-btn>
                      <span>Close</span>
                    </v-tooltip>
                  </div>
                </v-list-tile>
                <v-divider />
                <v-list-tile @click="complete(1)">
                  <v-list-tile-action>
                    <v-checkbox :value="list[1]" color="success" />
                  </v-list-tile-action>
                  <v-list-tile-title>Lines From Great Russian Literature? Or E-mails From My Boss?</v-list-tile-title>
                  <div class="d-flex">
                    <v-tooltip top content-class="top">
                      <v-btn slot="activator" class="v-btn--simple" color="danger" icon>
                        <v-icon color="error">mdi-close</v-icon>
                      </v-btn>
                      <span>Close</span>
                    </v-tooltip>
                  </div>
                </v-list-tile>
                <v-divider />
                <v-list-tile @click="complete(2)">
                  <v-list-tile-action>
                    <v-checkbox :value="list[2]" color="success" />
                  </v-list-tile-action>
                  <v-list-tile-title>Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit</v-list-tile-title>
                  <div class="d-flex">
                    <v-tooltip top content-class="top">
                      <v-btn slot="activator" class="v-btn--simple" color="danger" icon>
                        <v-icon color="error">mdi-close</v-icon>
                      </v-btn>
                      <span>Close</span>
                    </v-tooltip>
                  </div>
                </v-list-tile>
              </v-list>
            </v-tab-item>

            <!--Timeline-->
            <v-tab-item>
              <v-timeline align-top dense>
                <v-timeline-item color="pink" small>
                  <v-layout pt-3>
                    <v-flex xs3>
                      <strong>5pm</strong>
                    </v-flex>
                    <v-flex>
                      <strong>New Icon</strong>
                      <div class="caption">Mobile App</div>
                    </v-flex>
                  </v-layout>
                </v-timeline-item>

                <v-timeline-item color="teal lighten-3" small>
                  <v-layout wrap pt-3>
                    <v-flex xs3>
                      <strong>3-4pm</strong>
                    </v-flex>
                    <v-flex>
                      <strong>Design Stand Up</strong>
                      <div class="caption mb-2">Hangouts</div>
                      <v-avatar>
                        <v-img
                          src="https://avataaars.io/?avatarStyle=Circle&topType=LongHairFrida&accessoriesType=Kurt&hairColor=Red&facialHairType=BeardLight&facialHairColor=BrownDark&clotheType=GraphicShirt&clotheColor=Gray01&graphicType=Skull&eyeType=Wink&eyebrowType=RaisedExcitedNatural&mouthType=Disbelief&skinColor=Brown"
                        ></v-img>
                      </v-avatar>
                      <v-avatar>
                        <v-img
                          src="https://avataaars.io/?avatarStyle=Circle&topType=ShortHairFrizzle&accessoriesType=Prescription02&hairColor=Black&facialHairType=MoustacheMagnum&facialHairColor=BrownDark&clotheType=BlazerSweater&clotheColor=Black&eyeType=Default&eyebrowType=FlatNatural&mouthType=Default&skinColor=Tanned"
                        ></v-img>
                      </v-avatar>
                      <v-avatar>
                        <v-img
                          src="https://avataaars.io/?avatarStyle=Circle&topType=LongHairMiaWallace&accessoriesType=Sunglasses&hairColor=BlondeGolden&facialHairType=Blank&clotheType=BlazerSweater&eyeType=Surprised&eyebrowType=RaisedExcited&mouthType=Smile&skinColor=Pale"
                        ></v-img>
                      </v-avatar>
                    </v-flex>
                  </v-layout>
                </v-timeline-item>

                <v-timeline-item color="pink" small>
                  <v-layout pt-3>
                    <v-flex xs3>
                      <strong>12pm</strong>
                    </v-flex>
                    <v-flex>
                      <strong>Lunch break</strong>
                    </v-flex>
                  </v-layout>
                </v-timeline-item>

                <v-timeline-item color="teal lighten-3" small>
                  <v-layout pt-3>
                    <v-flex xs3>
                      <strong>9-11am</strong>
                    </v-flex>
                    <v-flex>
                      <strong>Finish Home Screen</strong>
                      <div class="caption">Web App</div>
                    </v-flex>
                  </v-layout>
                </v-timeline-item>
              </v-timeline>
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-flex>
      <!--End TODO-->
    </v-layout>
  </v-container>
</template>

<script>
import CustomerService from "@/api-services/customer.service.js";
import _ from "lodash";
import { error } from "util";
import router from "@/router";

export default {
  data: () => ({
    actions: [
      { title: "Home", icon: "dashboard" },
      { title: "About", icon: "question_answer" }
    ],
    right: null,

    //customer objects
    customer_external_id: "",
    customer_name: "",
    primary_contact: "",
    email: "",
    phone: "",
    address1: "",
    city: "",
    state: "",
    zip: "",
    active_since: "",
    is_company: true,
    ytd_commission: 0,
    all_commission: 0,
    current_year_premium: 0,
    total_lives: 0,
    last_commission_paid_date: "NA",
    last_commission_paid_amount: 0,

    //Customer Coverage items

    dialog: false,
    headers: [
      {
        text: "Coverage",
        align: "left",
        sortable: false,
        value: "coverage"
      },
      { text: "Carrier", value: "carrier" },
      { text: "Effective Date", value: "effective_date" },
      { text: "Status", value: "status" },
      { text: "Premium", value: "premium", sortable: true },
      { text: "Commission", value: "commission", sortable: true }
    ],
    tabs: 0,
    list: {
      0: false,
      1: false,
      2: false
    },
    items: [],
    editedIndex: -1,
    editedItem: {
      id:"",
      customer_external_id:"",
      coverage_external_id: "",
      carrier_external_id: "",
      effective_date: "",
      status: "",
      estimated_commission: 0,
      estimated_premium: 0,
      actual_commission: 0,
      actual_premium: 0,
      is_active:true,
      create_user:"",
      update_user:"",
      created_at:"",
      updated_at:"",
      deleted_at:""
    },
    defaultItem: {
       id:"",
      customer_external_id:"",
      coverage_external_id: "",
      carrier_external_id: "",
      effective_date: "",
      status: "",
      estimated_commission: 0,
      estimated_premium: 0,
      actual_commission: 0,
      actual_premium: 0,
      is_active:true,
      create_user:"",
      update_user:"",
      created_at:"",
      updated_at:"",
      deleted_at:""
    }
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Coverage" : "Edit Coverage";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.initialize();
  },

  complete(index) {
    this.list[index] = !this.list[index];
  },

  methods: {
    initialize() {
      CustomerService.get(this.$route.params.id)
        .then(response => {
          var customer = response.data.customer[0];
          console.log(customer);
          //Assign to fields
          this.customer_name = customer.name;
          this.customer_external_id = customer.customer_external_id;
          this.primary_contact = customer.name;
          this.email = _.chain(customer.email)
            .find({ type: "primary" })
            .get("email")
            .value();
          this.phone = _.chain(customer.phone)
            .find({ type: "primary" })
            .get("phone")
            .value();
          var address = _.chain(customer.address)
            .find({ type: "main" })
            .value();
          this.address1 = address.address1;
          this.city = address.city;
          this.state = address.state;
          this.zip = address.zip;
          this.active_since = customer.active_since;
          // this.is_company:true,
        })
        .catch(error => {
          console.log(error.response.data);
        });

      CustomerService.getCustomerCoverage(this.$route.params.id)
        .then(response => {
          var customerCoverage = response.data.customer_coverage;
          this.items = _.toArray(customerCoverage);
          console.log(this.items)
        })
        .catch(error => {
          console.log(error.response.data);
        });
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      console.log(item)
      const index = this.items.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.items.splice(index, 1);
        CustomerService.deleteCustomerCoverage(item.id)
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], this.editedItem);
        CustomerService.updateCustomerCoverage(this.editedItem.id,this.editedItem)
      } else {
        this.editedItem.customer_external_id=this.customer_external_id;
        this.editedItem.create_user=this.$store.state.current_user.user_external_id;
        this.editedItem.update_user=this.$store.state.current_user.user_external_id;
        this.items.push(this.editedItem);
        CustomerService.createCustomerCoverage(this.editedItem);
      }
      this.close();
    }
  }
};
</script>
